import { render, staticRenderFns } from "./ProductInvoiceDetail.vue?vue&type=template&id=7811257d&scoped=true&"
import script from "./ProductInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./ProductInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductInvoiceDetail.vue?vue&type=style&index=0&id=7811257d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7811257d",
  null
  
)

export default component.exports